import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { first, Observable } from 'rxjs';
import { PITEventService, UtilsMisc } from '@pit/core';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreFacade } from '@pit/core-store';
import { IDtoResourceFault } from '@pit/frontend-model';
import { DtoResourceFaultStoreFactory } from './dto.resource.fault.store.factory';
import { IDtoResourceFaultEntityDataService } from '../../module.data/services/interfaces/dto.resource.fault.entity.data.service.interface';

@Injectable({
    providedIn: 'root'
})
export class DtoResourceFaultStoreFacade extends EntityStoreFacade<IDtoResourceFault> {

    constructor(store: Store<IDtoResourceFault>, dataServiceAccessor: EntityDataServiceAccessorService, eventService: PITEventService) {
        super(DtoResourceFaultStoreFactory.instance, store, 'DtoResourceFault', dataServiceAccessor, eventService);
    }

    public getResourceFaultsForResourceType$(resourceType: string): Observable<IDtoResourceFault[]> {
        return this.store
            .select(this.entityStoreFactory.getSelector('get.for.resource.type')(resourceType));
    }

    public async getResourceFaultsForResourceTypeAsync(resourceType: string): Promise<IDtoResourceFault[]> {
        let result: IDtoResourceFault[] = [];
        try {
            result = await this.getResourceFaultsForResourceType$(resourceType).pipe(first()).toPromise();
        } catch {
        }

        return result;
    }

    public loadForMandatorByResourceType$(mandator: string, resourceType: string): void {
        this.store.dispatch(this.entityStoreFactory.getAction('get.by.mandator.resourcetype')({ mandator: mandator, resourceType: resourceType }));
    }

    public async loadForMandatorByResourceTypeAsync(mandator: string, resourceType: string): Promise<IDtoResourceFault[]> {
        let result: IDtoResourceFault[] = null;
        try {
            const queryResult: IDtoResourceFault[] = await (this.dataServiceAccessor.getEntityDataService<IDtoResourceFault>(this.entityStoreFactory.dataAccessName.toLowerCase()) as IDtoResourceFaultEntityDataService).getForMandatorByResourceTypeAsync(mandator, resourceType);
            this.clear();
            if ((UtilsMisc.isNullOrUndefined(queryResult) === false) && (queryResult.length > 0)) {
                result = queryResult;
                this.upsertItemsToStore(result);
            }
        } catch (error) {
        } finally {
        }

        return result;
    }

}
